// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorTraffic } from './escalator-traffic';


export class EscalatorTrafficMessage implements flatbuffers.IUnpackableObject<EscalatorTrafficMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorTrafficMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorTrafficMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorTrafficMessage):EscalatorTrafficMessage {
  return (obj || new EscalatorTrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorTrafficMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorTrafficMessage):EscalatorTrafficMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorTrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EscalatorTraffic {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EscalatorTraffic.P;
}

static startEscalatorTrafficMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EscalatorTraffic) {
  builder.addFieldInt16(0, message, EscalatorTraffic.P);
}

static endEscalatorTrafficMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEscalatorTrafficMessage(builder:flatbuffers.Builder, message:EscalatorTraffic):flatbuffers.Offset {
  EscalatorTrafficMessage.startEscalatorTrafficMessage(builder);
  EscalatorTrafficMessage.addMessage(builder, message);
  return EscalatorTrafficMessage.endEscalatorTrafficMessage(builder);
}

unpack(): EscalatorTrafficMessageT {
  return new EscalatorTrafficMessageT(
    this.message()
  );
}


unpackTo(_o: EscalatorTrafficMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): EscalatorTrafficMessageT {
  const t = new EscalatorTrafficMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class EscalatorTrafficMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EscalatorTraffic = EscalatorTraffic.P
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EscalatorTrafficMessage.createEscalatorTrafficMessage(builder,
    this.message
  );
}

clone(): EscalatorTrafficMessageT {
  const obj = new EscalatorTrafficMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: EscalatorTrafficMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyEscalatorTrafficMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
